import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import Sidebar from "./AdminSidebar";
import Navbar from "./AdminNavbar";
import { useState } from "react";

const drawerWidth = 240;
const collapsedWidth = 64;
const anchor = "right"; // Sidebar on the right

export default function AdminLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const sidebarWidth = isMobile ? 0 : sidebarOpen ? drawerWidth : collapsedWidth;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default", overflowX: "hidden" }}>
      <Sidebar
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
        open={sidebarOpen}
        mobileOpen={mobileSidebarOpen}
        isMobile={isMobile}
        onToggle={() => setSidebarOpen((prev) => !prev)}
        onCloseMobile={() => setMobileSidebarOpen(false)}
        anchor={anchor}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          minHeight: "100vh",
          width: { xs: "100%", md: `calc(100% - ${sidebarWidth}px)` },
          transition: (t) =>
            t.transitions.create(["margin", "width"], {
              easing: t.transitions.easing.sharp,
              duration: t.transitions.duration.shorter,
            }),
          ...(anchor === "left" ? { ml: { xs: 0, md: `${sidebarWidth}px` } } : { mr: { xs: 0, md: `${sidebarWidth}px` } }),
        }}
      >
        <Navbar
          sidebarWidth={sidebarWidth}
          anchor={anchor}
          isMobile={isMobile}
          onOpenSidebar={() => setMobileSidebarOpen(true)}
        />

        <Box sx={{ p: { xs: 1, sm: 1.5, md: 3 }, mt: { xs: 7.5, sm: 8, md: 8 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
